/**
 * @generated SignedSource<<6cd990f32353b88d9bdc17b200e5a3aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableDetailsTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetails_user" | "PdpRespSharedSellerDetails_user" | "PdpSharedBuyerIncentives_user">;
  readonly " $fragmentType": "PdpRespUnavailableDetailsTabs_user";
};
export type PdpRespUnavailableDetailsTabs_user$key = {
  readonly " $data"?: PdpRespUnavailableDetailsTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableDetailsTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableDetailsTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSellerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3d57cf1bfee43b6c1ecae5abf29421df";

export default node;
